module.exports = __webpack_public_path__ + "static/mulching-216191318a3f0b91fce99e217ea63bc4.svg";